<template>
    <modal @close="$emit('close')" :show-title="true">
        <div slot="header">
            <h5 class="modal-title">{{$t('attenzione_label').toUpperCase()}}</h5>
        </div>
        <div slot="body">
            <div>
                {{this.$tc('removed_free_pick_alert_1', this.freePicks.length)}}
            </div>
            <div class="mt-3 mb-3">
                <b v-for="free_pick in this.freePicks">
                    {{free_pick}} <br>
                </b>
            </div>
            <div>
                {{this.$tc('removed_add_free_pick_alert_2', this.freePicks.length)}}
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../partials/Modal';

    export default {
        name: "ModalRemovedFreePicks",
        components: {Modal},
        props: ['freePicks']
    }
</script>

<style scoped>

</style>
